define('frontend-common-components/objectStorageConfig/js/controllers/bucketListingController',[
    'marionette',
    'jquery'

], function (Marionette, $) {
    'use strict';

    var BucketListingController = Marionette.Object.extend({

        baseURL: '/',
        defaultOptionKeys: ['baseURL'],

        initialize: function (options) {
            this.mergeOptions(options, this.defaultOptionKeys);
        },

        getAWSBucketsList : function (arnRoleName) {
            return $.getJSON(this.getAWSObjectStorageURL(arnRoleName)).then(function (data) {
                return data.bucketNames;
            });
        },

        getAzureContainerList: function (account, key) {
            return $.getJSON(this.getAzureObjectStorageURL(account, key)).then(function (data) {
                return data.containerNames;
            });
        },

        getObjectStorage: function () {
            return this.baseURL + 'objectStorage';
        },

        getAWSObjectStorageURL: function (arnRoleName) {
            return this.getObjectStorage() + this.getAWSObjectStoragePath(arnRoleName);
        },
        
        getAzureObjectStorageURL: function (account, key) {
            return this.getObjectStorage() + this.getAzureObjectStoragePath(account, key);;
        },

        getAWSObjectStoragePath: function(arnRoleName) {
            return '/aws/buckets?roleARN=' + arnRoleName;
        },

        getAzureObjectStoragePath: function(account, key) {
            return '/azure/containers?accountName=' + account + '&accessKey=' + encodeURIComponent(key);
        }
    });
    
    return BucketListingController;
});
